import {ReactElement} from 'react';

export const MutedIcon = (): ReactElement => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 60 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.4499 58.0645C46.4839 58.0645 59.4821 45.0663 59.4821 29.0323C59.4821 12.9982 46.4839 0 30.4499 0C14.4158 0 1.4176 12.9982 1.4176 29.0323C1.4176 45.0663 14.4158 58.0645 30.4499 58.0645Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M34.63 23.4243L43.7271 32.6338"
        stroke="white"
        strokeWidth="1.45161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.7271 23.4243L34.63 32.6338"
        stroke="white"
        strokeWidth="1.45161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.8567 20.2855L22.747 24.8145H18.5664C17.8696 24.8145 17.1728 25.3952 17.1728 26.2081V31.7823C17.1728 32.5952 17.8696 33.1758 18.5664 33.1758H22.747L27.8567 37.821C28.089 38.0532 28.3212 38.1694 28.6696 38.1694C28.7857 38.1694 28.9019 38.1694 29.018 38.0532C29.4825 37.9371 29.7147 37.4726 29.7147 37.0081V20.9823C29.7147 20.5177 29.4825 20.1694 29.018 19.9371C28.6696 19.821 28.2051 19.9371 27.8567 20.2855Z"
        fill="white"
        stroke="white"
        strokeWidth="1.45161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UnMutedIcon = (): ReactElement => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 60 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.7069 58.0645C46.741 58.0645 59.7391 45.0663 59.7391 29.0323C59.7391 12.9982 46.741 0 30.7069 0C14.6728 0 1.67462 12.9982 1.67462 29.0323C1.67462 45.0663 14.6728 58.0645 30.7069 58.0645Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M34.1659 35.401C36.024 33.659 37.1853 31.2203 37.1853 28.5494C37.1853 25.8784 36.024 23.3236 34.1659 21.6978"
        stroke="white"
        strokeWidth="1.45161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.6946 40.1623C41.8301 37.2591 43.9204 33.1946 43.9204 28.5494C43.9204 23.9043 41.9462 19.8397 38.6946 16.9365"
        stroke="white"
        strokeWidth="1.45161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.4304 20.0731L22.3207 24.6021H18.1401C17.4433 24.6021 16.7465 25.1828 16.7465 25.9957V31.5699C16.7465 32.3828 17.4433 32.9634 18.1401 32.9634H22.3207L27.4304 37.6086C27.6627 37.8408 27.8949 37.957 28.2433 37.957C28.3594 37.957 28.4756 37.957 28.5917 37.8408C29.0562 37.7247 29.2884 37.2602 29.2884 36.7957V20.7699C29.2884 20.3053 29.0562 19.957 28.5917 19.7247C28.2433 19.6086 27.7788 19.7247 27.4304 20.0731Z"
        fill="white"
        stroke="white"
        strokeWidth="1.45161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
